import {type AppBskyGraphDefs} from '@atproto/api'
import {useQuery} from '@tanstack/react-query'

import {STALE} from '#/state/queries'
import {usePreferencesQuery} from '#/state/queries/preferences'
import {useAgent} from '#/state/session'

// Static list of Batesky featured starter packs
// Format: { handle: string, rkey: string }
const BATESKY_FEATURED_STARTER_PACKS = [
  {handle: 'batortay.bsky.social', rkey: '3lb5axoe6p42z'},
  {handle: 'dudeitsme.bsky.social', rkey: '3laxnsi3u752b'},
  {handle: 'poppernate.fans', rkey: '3lfoorhnbxt23'},
]

export const createSuggestedStarterPacksQueryKey = () => [
  'suggested-starter-packs',
]

export function useSuggestedStarterPacksQuery({enabled}: {enabled?: boolean}) {
  const agent = useAgent()
  const {data: preferences} = usePreferencesQuery()

  return useQuery({
    enabled: !!preferences && enabled !== false,
    staleTime: STALE.MINUTES.THREE,
    queryKey: createSuggestedStarterPacksQueryKey(),
    async queryFn() {
      // Fetch all starter packs metadata in parallel
      const packResults = await Promise.all(
        BATESKY_FEATURED_STARTER_PACKS.map(async ({handle, rkey}) => {
          try {
            // First resolve the handle to a DID
            const resolveRes = await agent.resolveHandle({handle})
            const did = resolveRes.data.did
            const uri = `at://${did}/app.bsky.graph.starterpack/${rkey}`

            // Then fetch the starter pack
            const res = await agent.app.bsky.graph.getStarterPack({
              starterPack: uri,
            })
            return res.data.starterPack
          } catch {
            return null
          }
        }),
      )

      // Filter out nulls (failed fetches)
      const starterPacks = packResults.filter(
        (pack): pack is AppBskyGraphDefs.StarterPackView => pack !== null,
      )

      return {starterPacks}
    },
  })
}
